export enum StripeBankStatusEnum {
  'PENDING_VERIFICATION' = 0,
  'VERIFIED' = 2,
}
